import React from "react";
import { UserScore } from "../../core/_models";
import { getColor } from "./PESLayout2";
type Props = {
    showProgress?: boolean;
    scoreData: UserScore[]
};

const Avatar = ({ initials, bg }: { initials: string; bg: string }) => {
    return (
        <div
            className={`symbol symbol-40px`}
            style={{ minWidth: 40 }}
        >
            <div
                className={`symbol-label bg-${bg} text-white fw-bold`}
                style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {initials}
            </div>
        </div>
    );
};

const EvaluatorList: React.FC<Props> = ({ showProgress = false, scoreData }) => {
    return (
        <div className="d-flex flex-column gap-5 w-100">
            {scoreData.map((user, index) => {
                return (
                    <div key={index} className="d-flex justify-content-between w-100">
                        <div className="d-flex align-items-center gap-2">
                            <Avatar initials={user.initials} bg={'dark bg-opacity-50'} />

                            <div className="ms-3">
                                <div className="fw-semibold text-gray-900">
                                    {user.name}
                                </div>
                                <div className="text-muted fs-7">
                                    {user.email}
                                </div>
                            </div>
                        </div>
                        {showProgress ? (
                            <div className="w-300px">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="fw-bold text-gray-900">Score</span>
                                    <span className="fw-bold" style={{ color: getColor(user.score) }}>{user.score}%</span>
                                </div>

                                <div className="progress h-15px mb-3">
                                    <div className={`progress-bar`} style={{ width: `${user.score}%`, background: getColor(user.score) }} />
                                </div>
                            </div>
                        ) : (
                            <div className="border border-gray-500 border-dashed min-w-50px rounded py-1 px-1 d-flex align-items-center justify-content-center">
                                <div className="fs-5 fw-bolder">{user.score}%</div>
                            </div>)}
                    </div>
                )
            })}
        </div>
    );
};

export default EvaluatorList;
